import HeroSection from '@/v2/components/sections/common/hero-section'
import NewsArticle from '@/v2/components/sections/common/news-article'
import PaginationSection from '@/v2/components/sections/common/pagination-section'
import ShowcaseSection from '@/v2/components/sections/common/showcase-section'

import {
  heroSectionContent,
  paginationSectionContent,
  showcaseSectionContent
} from '@/v2/constants/pages/public-pages/news-and-press-page'

interface NewsAndPressPageProps {}

const NewsAndPressPage: React.FC<NewsAndPressPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName='w-[324px] h-[218px] md-mn:w-[380px] md-mn:h-[286px] lg:!w-[448px] lg:!h-[313px] xl-min:!w-[680px] xl-min:!h-[458px]'
      />
      <ShowcaseSection {...showcaseSectionContent} />
      <PaginationSection {...paginationSectionContent} articlesPerPage={8} ArticleComponent={NewsArticle} />
    </>
  )
}

export default NewsAndPressPage
